import { ArrowSmallRightIcon, EnvelopeIcon, PhoneIcon, StarIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

import Avatar from "~/components/Avatar";
import Headline from "~/components/Headline";

interface Props {
	firstName: string;
	lastName: string;
	clientDisplayName?: string;
	title: string | null;
	description: string | null;
	emailBusiness: string | null;
	phone: string | null;
	href: string | null;
}

const ContactCard: React.FC<Props> = ({
	firstName,
	lastName,
	clientDisplayName,
	title,
	description,
	emailBusiness,
	phone,
	href,
}) => {
	const CardContent = () => (
		<div className="group flex w-full items-center justify-between space-x-6 bg-white p-6">
			<div className="flex-1 truncate">
				<div className="flex items-center space-x-3">
					<Headline type="h5" className="group-hover:text-secondary-500">
						{title} {firstName} {lastName}
					</Headline>
				</div>
				{clientDisplayName && (
					<div className="mt-1 flex flex-row items-center gap-1 truncate text-sm text-gray-500">
						<StarIcon className="size-4" />
						{clientDisplayName}
					</div>
				)}
				{description && (
					<div className="flex flex-row items-center gap-1 truncate text-xs text-gray-500">
						<ArrowSmallRightIcon className="size-4" />
						{description}
					</div>
				)}
			</div>
			<Avatar firstName={firstName} lastName={lastName} />
		</div>
	);
	return (
		<div
			className={clsx(
				"col-span-1 transform-gpu divide-y divide-gray-200 rounded-lg shadow transition-transform duration-200",
				"overflow-hidden bg-white",
				"hover:shadow-md",
			)}
		>
			{href ? (
				<NavLink to={href}>
					<CardContent />
				</NavLink>
			) : (
				<CardContent />
			)}

			{(emailBusiness || phone) && (
				<div>
					<div className="-mt-px flex divide-x divide-gray-200">
						{emailBusiness && (
							<div className="flex w-0 flex-1">
								<a
									href={`mailto:${emailBusiness}`}
									className={clsx(
										"relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 py-4",
										"rounded-bl-lg border border-transparent",
										"text-sm font-semibold text-gray-700",
										"hover:bg-secondary-500 hover:text-white",
										"transition-all duration-200",
									)}
								>
									<EnvelopeIcon className="size-5 text-current" aria-hidden="true" />
									Email
								</a>
							</div>
						)}
						{phone && (
							<div className="-ml-px flex w-0 flex-1">
								<a
									href={`tel:${phone}`}
									className={clsx(
										"relative inline-flex w-0 flex-1 items-center justify-center gap-x-3 py-4",
										"rounded-br-lg border border-transparent",
										"text-sm font-semibold text-gray-900",
										"hover:bg-secondary-500 hover:text-white",
										"transition-all duration-200",
									)}
								>
									<PhoneIcon className="size-5 text-current" aria-hidden="true" />
									Anrufen
								</a>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default ContactCard;
